const projectData = [
    {
        image_url: require('./images/projects/fine_tune_mistral.png'),
        title: 'Immigration Law Chatbot',
        description: "Developed and Fine-tuned Mistral-7B-instruct LLM on AWS SageMaker for legal Q&A, leveraging a 9,000+ pair custom \
        dataset. \
        Architected and deployed a production-ready, scalable LLM inference system on AWS Lambda and API Gateway, reducing \
        hallucination and ensuring answer relevance by integrating Retrieval-Augmented Generation via Amazon OpenSearch. \
        Engineered robust data pipelines for LLM training and RAG knowledge base, ensuring reliable and seamless ingestion and \
        retrieval of large datasets and source documents from AWS S3.",
        link: '',
        subject: 'Fine-Tuned LLM with RAG on AWS'
    },
    {
        image_url: require('./images/projects/splitwiser.png'),
        title: 'Splitwiser – A Splitwise clone',
        description: "Created a Splitwise-inspired application featuring receipt scanning via camera or file upload, \
        group and non-group expense tracking, and dynamic graphical and manual split functionalities.\
        Leveraged Google Gemini API to convert receipt images into JSON data, facilitating graphical expense visualization.\
        Utilized NextJS for UI and API development, Google Firebase for backend services, and Firestore for storing receipt data.",
        link: '',
        subject: 'Full Stack Development, LLM'
    },
    {
        image_url: require('./images/projects/autokube.png'),
        title: 'Autokube',
        description: "Automated Kubernetes cluster creation and modification, automating DevOps workflows for JavaScript and Python-based \
        applications, reducing deployment time by over 80%. \
        Orchestrated the dynamic generation of Dockerfiles and Kubernetes manifests based on user input, ensuring consistent and \
        reproducible deployments, leading to a 40% reduction in infrastructure setup time. \
        Developed robust APIs using Express.js, designed reusable components using React.js, and MongoDB for user data storage, \
        enabling deployments with just 3 clicks.",
        link: '',
        subject: 'Devops Automation'
    },
    {
        image_url: require('./images/projects/CAO.png'),
        title: 'Design and Implementation of Instruction Pipeline of Processors',
        description: "Planned and executed a superscalar, out-of-order pipeline simulator in C with 12 stages \
        including fetch, decode, instruction analysis, renaming, execution, and retirement, supporting 19 instruction types.\
        Integrated Branch Table Buffer and branch prediction mechanisms, reducing pipeline stalls by 50%.\
        Implemented advanced out-of-order processing, including instruction renaming, and dependency analysis",
        link: '',
        subject: 'Computer Architechture'
    },
    {
        image_url: require('./images/projects/RAT.png'),
        title: 'Remote Access Trojan (RAT) with KeyLogging – A Study',
        description: "Demonstrated how attackers can execute commands remotely using RAT and capture sensitive information using social\
        engineering and network vulnerabilities.\
        Utilized Python for RAT creation, Snort for intrusion detection, Suricata for prevention, and a honeypot to analyze behavior.\
        Successfully detected and mitigated attacks while diverting threats to decoy systems.",
        link: '',
        subject: 'Cyber Security'
    },
    {
        image_url: require('./images/projects/CNN.png'),
        title: 'Gender recognition Android app',
        description: "Worked in a team of 3 to create a web application using Google Colab and a dataset from Kaggle \
        to detect gender of a given image, achieved 96% accuracy which was presented in front of 100+ students and faculty members.",
        link: '',
        subject: 'Convolutional Neural Networks'
    },
    {
        image_url: require('./images/projects/atari.png'),
        title: 'Deep Q Learning network to play Atari games',
        description: "Implementation of DQN using tensorflow to play complex Atari games by passing the pixels on the screen to the network.",
        link: '',
        subject: 'Reinforcement Learning Project'
    },
    {
        image_url: require('./images/projects/ResNet50.png'),
        title: 'Optical Character Recognition with ResNet50',
        description: "Built a Resnet model using Keras framework that can recognize a character present on the screen.",
        link: '',
        subject: 'Convolutional Neural Networks'
    },
    {
        image_url: require('./images/projects/car.png'),
        title: 'Online Car Rental System website',
        description: "Modeled a web application using Django framework to rent cars online where company can list their cars. Customers can book more \
        than 1 car from the same of a different company.",
        link: '',
        subject: 'FullStack Development Project'
    },
    {
        image_url: require('./images/projects/YES.png'),
        title: 'Developed a Web App for the YES!+ club of BIT',
        description: "A platform where all the club members can see the details of the upcoming events, members of the club \
        and also previous events summary. MERN stack was used to achieve the same.",
        link: '',
        subject: 'FullStack Development Project'
    },

]

export default projectData